/**
 * Nombres de presentación por variante.
 *
 * El exportador genera el nombre de cada variante concatenando el ítem base con "+nivel"
 * (p. ej. "Scroll of the Emperor +1"). Ese texto NO demuestra cómo se llama el objeto en el cliente.
 * Aquí se fija el nombre que ve el jugador, con su procedencia. El nombre exportado se conserva
 * aparte (ItemVariant.exportedName) y los identificadores, rutas, drops y requisitos no cambian.
 *
 * Hasta tener el nombre del cliente de Vanguard, estos nombres son de referencia.
 */
export type VariantDisplayName = {
  displayName: string
  /** Procedencia del nombre mostrado. */
  source: string
  sourceUrl?: string
  /** Para qué se usa, en palabras del jugador. */
  context: string
  /** Nombres alternativos para el buscador. */
  aliases: string[]
}

const WEBZEN_MARLON = 'https://muonline.webzen.com/en/gameinfo/guide/detail/83'

export const variantDisplayNames: Record<string, VariantDisplayName> = {
  '14,23@0': {
    displayName: 'Scroll of the Emperor',
    source: 'Nombre del catálogo de Vanguard (ítem base 14,23)',
    context: 'Objeto de la primera parte de Sebina',
    aliases: ['scroll of emperor', 'pergamino del emperador', 'librito', 'libro de sebina'],
  },
  '14,24@0': {
    displayName: 'Broken Sword',
    source: 'Nombre del catálogo de Vanguard (ítem base 14,24)',
    context: 'Objeto de la segunda parte de Sebina para Dark Knight',
    aliases: ['espada rota', 'hachita', 'objeto sebina dk'],
  },
  '14,23@1': {
    displayName: 'Ring of Honor',
    source: 'Nombre de referencia clásico de MU Online (Webzen lo publica como Ring of Glory)',
    sourceUrl: WEBZEN_MARLON,
    context: 'Anillo de la primera parte de Marlon',
    aliases: ['ring of glory', 'anillo de marlon', 'anillo de honor', 'anillo de gloria'],
  },
  '14,24@1': {
    displayName: 'Dark Stone',
    source: 'Nombre de referencia oficial de MU Online (Webzen)',
    sourceUrl: WEBZEN_MARLON,
    context: 'Objeto de la parte adicional de Marlon, solo Blade Knight',
    aliases: ['piedra oscura', 'objeto combo', 'combo bk'],
  },
}

export const variantDisplayName = (id: string) => variantDisplayNames[id]
